import { AppointmentExchangeHistoryEntryResponse } from "@/api";
import { ColumnFilterOption } from "@/common/components/table/ColumnFilterHeader";
import { DataTable } from "@/common/components/table/DataTable";

import { useExchangeHistoryColumns } from "../hooks/useExchangeHistoryColumns";

const ROW_HEIGHT = 60;
const COLUMN_HEADER_HEIGHT = 56;

interface Props {
  rows: AppointmentExchangeHistoryEntryResponse[];
  isLoading: boolean;
  paginationResetKey: string;
  serviceOptions: ColumnFilterOption[];
  givenServiceFilter: string | null;
  onGivenServiceFilterChange: (value: string | null) => void;
  receivedServiceFilter: string | null;
  onReceivedServiceFilterChange: (value: string | null) => void;
}

/** Flat, read-only list of carried-out swaps, newest first; rows open nothing. */
export function ExchangeHistoryTable({ rows, isLoading, paginationResetKey, ...filterProps }: Props) {
  const columns = useExchangeHistoryColumns(filterProps);

  return (
    <DataTable
      data={rows}
      columns={columns}
      getRowId={(row) => row.exchangeId}
      isLoading={isLoading}
      rowHeight={ROW_HEIGHT}
      columnHeaderHeight={COLUMN_HEADER_HEIGHT}
      initialSortModel={[{ field: "acceptedAtUtc", sort: "desc" }]}
      disableColumnMenu
      paginationResetKey={paginationResetKey}
    />
  );
}
